import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import {
  DialogProps,
  FormControls,
  FormikDialog,
  FormikTextField,
} from 'components';
import { TranslationNamespace } from 'i18n';
import { RequisitesGroup } from 'types';

export const CreateRequisiteGroupDialog: React.FC<DialogProps> = ({
  open,
  onClose,
}) => {
  const { t: tCommon } = useTranslation();
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.requisites.group_details',
  });

  const initialValues: Partial<RequisitesGroup> = useMemo(
    () => ({
      name: '',
      requisites: [],
    }),
    [],
  );

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string().required(tCommon('errors.required')),
      }),
    [tCommon],
  );

  return (
    <FormikDialog
      formikProps={{
        initialValues,
        validationSchema,
        validateOnMount: true,
      }}
      dialogProps={{
        open,
        title: t('create.title'),
        onClose,
      }}
    >
      {() => (
        <FormControls>
          <FormikTextField
            required
            name="name"
            label={t('fields.name')}
            fullWidth
          />
        </FormControls>
      )}
    </FormikDialog>
  );
};
